import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CbbButtonVariant } from '../../../../../../../shared/cbb-button/cbb-button.component';

@Component({
  selector: 'app-politicas-entrega-confirm-delete-modal',
  templateUrl: './politicas-entrega-confirm-delete-modal.component.html',
  styleUrls: ['./politicas-entrega-confirm-delete-modal.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PoliticasEntregaConfirmDeleteModalComponent {
  @Input() loading = false;
  @Input() title = 'Confirmar eliminación';
  @Input() message = '¿Desea eliminar esta política de entrega? Esta acción no se puede deshacer.';
  @Input() entityLabel = 'política de entrega';
  @Input() confirmButtonLabel = 'Confirmar eliminación';
  @Input() confirmColor: CbbButtonVariant = 'danger';

  @Output() closeRequested = new EventEmitter<void>();
  @Output() confirmRequested = new EventEmitter<void>();

  onClose(): void {
    this.closeRequested.emit();
  }

  onConfirm(): void {
    this.confirmRequested.emit();
  }
}
